<template>
  <b-container>
    <b-row v-if="title">
      <b-col><h3>{{ title }}</h3></b-col>
    </b-row>
    <b-row v-if="description">
      <b-col
        class="description"
        v-html="description"
      />
    </b-row>
    <b-row class="form-row">
      <b-col>
        <template v-if="formLoading">
          <loading-spinner>
            <template v-slot:message>
              Loading form
            </template>
          </loading-spinner>
        </template>
        <template v-else>
          <no-ssr>
            <form-renderer
              :form="formItem"
              :data="formfieldtokens"
              :recaptcha-key="recaptchaKey"
              @success="formSubmissionSucceed"
              @failure="formSubmissionFailed"
            />
          </no-ssr>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import applogger from '@applogger'
import LoadingSpinner from '@aspedia/loading-spinner'
import DayJS from 'dayjs'

export default {
  name: 'slice-type-form',
  components: {
    'form-renderer': () => import('dev/vuejs-forms/src/components/FormRenderer'),
    'loading-spinner': LoadingSpinner
  },
  props: {
    slice: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      formItem: {
        form: null,
        actions: null
      },
      formLoading: true
    }
  },
  computed: {
    data() {
      return this.slice.data
    },
    title() {
      return this.data.title
    },
    description() {
      return this.data.description
    },
    formfieldtokens: function() {
      return {
        userid: this.$store.getters['user/userid'],
        order: this.item,
        club: {
          name: this.getClubName,
          bottles: this.getNoItems,
          frequency: this.getFrequency
        },
        site: {
          name: this.$store.getters.getSiteSetting('title', 'Incipere'),
          siteid: this.$store.getters.getSiteId
        },
        general: {
          date: DayJS(new Date()).format('DD/MM/YYYY'),
          time: DayJS(new Date()).format('HH:MM:SS'),
          datetime: DayJS(new Date()).format('DD/MM/YYYY HH:MM:SS')
        },
        person: this.$store.getters['user/isLoggedIn'] ? {
          name: this.$store.getters['user/fullname'],
          email: this.$store.getters['user/mail']
        } : {}
      }
    },
    recaptchaKey: function() {
      try {
        const moduleSetting = this.$store.getters['getModuleSetting']
        return moduleSetting('captcha', 'recaptchav2-key')
      }
      catch (err) {
        applogger.error(`Could not load recaptcha key: ${err.message}`)
        return null
      }
    }
  },
  mounted() {
    const formID = this.slice.data.formid
    const formEndpointUrl = this.$store.getters.getServiceEndpoint('circumspectis') + `/api/v1/form/${formID}`
    const siteID = this.$store.getters.getSiteId
    fetch(formEndpointUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Site-ID': siteID
      }
    })
      .then(resp => {
        if (resp.ok) {
          return resp.json()
            .then(data => {
              this.formItem = {
                formid: this.slice.data.formid,
                ...data.formdata
              }
              this.formLoading = false
            })
        }
        throw new Error(`Could not load form data for ID: ${formID} - ${resp.status} - ${resp.statusText}`)
      })
      .catch(err => {
        applogger.error(err)
      })
  },
  methods: {
    formSubmissionSucceed: function(results) {
      results.forEach(msg => {
        const statusMessage = {
          type: (msg.status === undefined) ? 'info' : (msg.status) ? 'success' : 'error',
          title: msg.title || 'Form Submission Successful',
          text: msg.text,
          notification: false,
          showClose: true,
          timeout: 6000
        }
        this.$eventHub.$emit('statusMessage', statusMessage)
      })
    },
    formSubmissionFailed: function(results) {
      const statusMessage = {
        type: 'error',
        title: 'Form Submission Unsuccessful',
        text: results.message,
        notification: false,
        showClose: true,
        timeout: 6000
      }
      this.$eventHub.$emit('statusMessage', statusMessage)
    }
  }
}
</script>

<style scoped lang="scss">
  h3, .description {
    text-align: center;
  }
</style>
